export default __webpack_public_path__ + "static/media/a2.4a6e788a.JPG";